import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import Layout from '../../components/Layout/Layout';
import {
  SubTitleH2,
  LoadSpinner,
  DefaultButton,
  ScoreTable,
  ScoreTableOral,
  ArrowLeftIndex,
  ModalAction
} from '../../components';
import StatBox from '../../components/StatBox/StatBox';
import {
  getOneQuizReviews,
  updateQuizReview,
  setDateQuizReview,
  clearProcessBubbleSheetErrors
} from '../../actions/score';

import { closeImportWindow } from '../../actions/student';

class AddScorePlatform extends Component {
  constructor() {
    super();
    this.state = {
      modalShow: false,
      modalData: {
        title: ''
      }
    };
  }

  componentDidMount() {
    const {
      match: { params },
      dispatch
    } = this.props;
    dispatch(getOneQuizReviews(params.id));
  }

  handleUpdate = () => {
    const { dispatch, quizReview, history } = this.props;
    dispatch(
      updateQuizReview({
        id: quizReview.id,
        review: { ...quizReview }
      })
    );
    history.push('/score');
  };

  onChangeDate = date => {
    const { dispatch } = this.props;

    dispatch(setDateQuizReview(date));
  };

  setModalShow = state => {
    this.setState({
      modalShow: state
    });
  };

  handleUpload = () => {
    const { dispatch, quizReview } = this.props;
    dispatch(closeImportWindow());
    this.setState({
      modalShow: true,
      modalData: {
        id: quizReview.id,
        create: true,
        action: 'edit',
        form: 'upload-file',
        title: 'IMPORTAR PUNTAJES'
      }
    });
  };

  handleAIUpload = () => {
    const { dispatch, quizReview } = this.props;
    dispatch(closeImportWindow());
    this.setState({
      modalShow: true,
      modalData: {
        id: quizReview.id,
        quizId: quizReview.quiz?.id,
        sectionId: quizReview.section?.id,
        create: true,
        action: 'edit',
        form: 'upload-file',
        title: 'INGRESA PUNTAJES CON IA'
      }
    });
  };

  handleBubbleSheetUpload = () => {
    const { dispatch, quizReview } = this.props;
    dispatch(closeImportWindow());
    this.setState({
      modalShow: true,
      modalData: {
        id: quizReview.id,
        create: true,
        action: 'edit',
        form: 'upload-file',
        title: 'PROCESAR RESULTADOS SIMCE'
      }
    });
  };

  handleDismissBubbleSheetErrors = () => {
    const { dispatch } = this.props;
    dispatch(clearProcessBubbleSheetErrors());
  };

  renderBubbleSheetErrors = () => {
    const { processBubbleSheetErrors } = this.props;
    if (!processBubbleSheetErrors || processBubbleSheetErrors.length === 0) {
      return null;
    }
    const count = processBubbleSheetErrors.length;
    return (
      <Row className="mt-3">
        <Col>
          <div
            style={{
              border: '1px solid #F5C2C7',
              backgroundColor: '#FDEDED',
              borderRadius: 4,
              padding: '12px 16px'
            }}
          >
            <div className="d-flex justify-content-between align-items-start">
              <strong>
                {count} {count === 1 ? 'hoja con errores' : 'hojas con errores'}
              </strong>
              <button
                type="button"
                className="close"
                aria-label="Cerrar"
                onClick={this.handleDismissBubbleSheetErrors}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <ul className="mb-0 mt-2">
              {processBubbleSheetErrors.map(e => (
                <li key={`${e.image}-${e.error}`}>
                  <strong>{e.image}:</strong> {e.error}
                </li>
              ))}
            </ul>
          </div>
        </Col>
      </Row>
    );
  };

  isStudentComplete = student => {
    if (!student.question_reviews_attributes) return false;
    return !student.question_reviews_attributes.some(question => {
      if (question.question_type === 'choices') {
        return !question.answer;
      }
      if (
        question.question_type === 'long' ||
        question.question_type === 'reading'
      ) {
        if (question.answer === 0) {
          return false;
        }
        return !(question.answer || question.percentage);
      }
      return false;
    });
  };

  calculateStats = () => {
    const { quizReview } = this.props;
    const students = quizReview.student_reviews_attributes || [];

    if (students.length === 0) {
      return { absent: 0, complete: 0, incomplete: 0, total: 0 };
    }

    const total = students.length;
    const attendedStudents = students.filter(s => s.attended);
    const attended = attendedStudents.length;
    const absent = total - attended;

    const completeStudents = attendedStudents.filter(s =>
      this.isStudentComplete(s)
    );
    const complete = completeStudents.length;
    const incomplete = attended - complete;

    return {
      absent: {
        count: absent,
        percentage: total > 0 ? Math.round((absent / total) * 100) : 0
      },
      complete: {
        count: complete,
        percentage: total > 0 ? Math.round((complete / total) * 100) : 0
      },
      incomplete: {
        count: incomplete,
        percentage: total > 0 ? Math.round((incomplete / total) * 100) : 0
      },
      total
    };
  };

  render() {
    const { ongoingRequest, onRequest, quizReview, time } = this.props;
    const { modalShow, modalData } = this.state;
    const date = quizReview.quiz_date || moment();
    const stats = this.calculateStats();

    return (
      <Layout>
        <Container fluid>
          <Row>
            <Col role="main">
              {(ongoingRequest.getRegions ||
                onRequest.getOneQuizReviews ||
                onRequest.updateQuizReview) && <LoadSpinner />}
              <div className="section">
                <ArrowLeftIndex className="mb-4 text-light" path="/score" />
                <SubTitleH2 text="Ingreso de puntajes" />
                <Row className="mt-5">
                  <Col>
                    <span>
                      <strong>
                        {quizReview.quiz ? quizReview.quiz.name : ''}
                      </strong>
                    </span>
                    <br />
                    <span>
                      {quizReview.section ? quizReview.section.full_name : ''}
                    </span>
                    <br />
                    <span>
                      {quizReview.section
                        ? quizReview.section.establishment_name
                        : ''}
                    </span>
                    <br />
                    <span>
                      {quizReview.section ? quizReview.section.year : ''}
                    </span>
                  </Col>

                  <Col xs={7}>
                    <Row>
                      <Col lg={3} className="py-1 py-lg-0">
                        <DefaultButton
                          style={{ width: '100%' }}
                          text="Automático IA"
                          variant="secondary"
                          onClick={() => this.handleAIUpload()}
                        />
                      </Col>
                      <Col lg={3} className="py-1 py-lg-0">
                        <DefaultButton
                          style={{ width: '100%' }}
                          text="Simce IA"
                          variant="secondary"
                          onClick={() => this.handleBubbleSheetUpload()}
                        />
                      </Col>
                      <Col lg={3}>
                        <DefaultButton
                          style={{ width: '100%' }}
                          text="Importar"
                          variant="secondary"
                          onClick={() => this.handleUpload()}
                        />
                      </Col>
                      <Col lg={3} className="py-1 py-lg-0">
                        <DefaultButton
                          style={{ width: '100%' }}
                          text="Guardar"
                          variant="secondary"
                          onClick={() => this.handleUpdate()}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {this.renderBubbleSheetErrors()}
                <Row className="mt-3">
                  <Col xs={2}>
                    <p className="mt-2">Fecha de revisión:</p>
                  </Col>
                  <Col xs={2}>
                    <DatePicker
                      style={{ width: 200 }}
                      dateFormat="dd-MM-yyyy"
                      required
                      selected={moment(date).toDate()}
                      onChange={e => this.onChangeDate(e)}
                    />
                  </Col>
                </Row>
                <Row className="mt-3 mb-3">
                  <Col xs="12" md="4" className="mb-md-0 mb-3">
                    <StatBox
                      label="Incompleto"
                      percentage={`${stats.incomplete.percentage ||
                        0}% de estudiantes`}
                      total={stats.incomplete.count || 0}
                      lipColor="#FBE5A2"
                      bodyColor="#FEFAEC"
                    />
                  </Col>
                  <Col xs="12" md="4" className="mb-md-0 mb-3">
                    <StatBox
                      label="Completado"
                      percentage={`${stats.complete.percentage ||
                        0}% de estudiantes`}
                      total={stats.complete.count || 0}
                      lipColor="#B2E486"
                      bodyColor="#F0FAE7"
                    />
                  </Col>
                  <Col xs="12" md="4">
                    <StatBox
                      label="Ausentes"
                      percentage={`${stats.absent.percentage ||
                        0}% de estudiantes`}
                      total={stats.absent.count || 0}
                      lipColor="#EAECEF"
                      bodyColor="#FFFFFF"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div>
                      <p>
                        <b>
                          Nota: Los alumnos que no tengan una revisión completa
                          (con un ticket al final de su fila), serán dejados
                          como ausentes al momento de guardar.
                        </b>
                      </p>
                    </div>
                    <div style={{ textAlign: 'right', opacity: 0.7 }}>
                      {time ? (
                        <p>Tus cambios fueron guardados a las {time}</p>
                      ) : (
                        <p> </p>
                      )}
                    </div>
                  </Col>
                </Row>
                {!onRequest.getOneQuizReviews &&
                  quizReview &&
                  quizReview.reading && <ScoreTableOral data={quizReview} />}

                {!onRequest.getOneQuizReviews &&
                  quizReview &&
                  !quizReview.reading && <ScoreTable data={quizReview} />}
              </div>
            </Col>
          </Row>
          <ModalAction
            show={modalShow}
            data={modalData}
            title="edit"
            onHide={() => this.setModalShow(false)}
          />
        </Container>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  const { ongoingRequest } = state.utils;
  const {
    ongoingRequest: onRequest,
    quizReview,
    time,
    processBubbleSheetErrors
  } = state.score;
  return {
    ongoingRequest,
    onRequest,
    quizReview,
    time,
    processBubbleSheetErrors
  };
};

export default connect(mapStateToProps)(AddScorePlatform);
